module.exports = __webpack_public_path__ + "8b7cbf02bc23d0b7f7fb9038eaf0b89d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/Rist/content/images/works/work_1_768_624_3.jpg
// module id = 890
// module chunks = 0